/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
  return item && typeof item === "object" && !Array.isArray(item);
}

/**
 * Deep clone an object. Uses structuredClone when available, else JSON parse/stringify.
 * @param {*} obj
 * @returns {*}
 */
export function deepClone(obj) {
  if (obj === null || typeof obj !== "object") return obj;
  if (typeof structuredClone === "function") return structuredClone(obj);
  return JSON.parse(JSON.stringify(obj));
}

/**
 * Deep merge two objects.
 * - Clones the base object once, then mutates nested branches properly
 * - Arrays from source REPLACE target arrays (no concatenation)
 */
export function mergeDeep(obj, ...sources) {
  const target = structuredClone(obj);
  if (!sources.length) return target;

  const applySource = (t, s) => {
    if (!isObject(s)) {
      return s;
    }
    // ensure target branch is object
    if (!isObject(t)) {
      t = {};
    }
    Object.keys(s).forEach((key) => {
      const sVal = s[key];
      const tVal = t[key];
      if (Array.isArray(sVal)) {
        // arrays: replace
        t[key] = structuredClone(sVal);
      } else if (isObject(sVal)) {
        t[key] = applySource(isObject(tVal) ? tVal : {}, sVal);
      } else {
        t[key] = sVal;
      }
    });
    return t;
  };

  let result = target;
  for (const source of sources) {
    if (source == null) continue;
    result = applySource(result, source);
  }
  return result;
}

export const getNestedFormValue = (values, name) => {
  let value;
  if (name.includes(".")) {
    const names = name.split(".");
    let root = values[names[0]];
    names.slice(1).forEach((name) => (root = root && root[name]));
    value = root;
  } else {
    value = values[name];
  }
  return value;
};
